import React from 'react';
import { useProduct } from '../../../features/pdp';
import * as styles from './styles.module.scss';
import { SKU_HARDCOVER, SKU_PHOTO_WRAPPED_HARDCOVER, SKU_PHOTO_WRAPPED_LAYFLAT } from 'components/constants/products';

export const SocialProof: React.FC = () => {
  const { product } = useProduct();

  const socialProofText = getSocialProofText(product.sku);

  if (!socialProofText) {
    return null;
  }

  return (
    <div className={styles.container}>
      {socialProofText}
    </div>
  );
};

const getSocialProofText = (sku: string) => {
  switch (sku) {
    case SKU_PHOTO_WRAPPED_LAYFLAT:
      return 'Designer favorite';
    case SKU_PHOTO_WRAPPED_HARDCOVER:
      return 'Bestseller';
    case SKU_HARDCOVER:
      return '1k+ 5-star reviews';
    default:
      return '';
  }
};
